import { useCallback } from 'react'

export interface PaginationItem {
  id: number
  name: string
}

/**
 * Reusable pagination logic for Growth Wheel views (competency list or area list).
 * Returns current index and handlers that navigate by index and call onItemChange with the item.
 */
export const useGrowthWheelPagination = <T extends PaginationItem>(
  list: T[],
  currentItem: T,
  onItemChange: (item: T | null) => void
) => {
  const currentItemIndex = list.findIndex((item) => item.id === currentItem.id) 
  const currentIndex = currentItemIndex !== -1 ? currentItemIndex : 0

  const handlePrevious = useCallback(
    (index: number) => {
      const item = list[index]
      if (item) onItemChange(item)
    },
    [list, onItemChange]
  )

  const handleNext = useCallback(
    (index: number) => {
      const item = list[index]
      if (item) onItemChange(item)
    },
    [list, onItemChange]
  )

  return {
    currentIndex,
    handlePrevious,
    handleNext,
  }
}
